import net from 'net'
import { DEFAULT_PORT } from './http-hook.enum'

const HTTP_CLOSE_CONNECTION = 'HTTP/1.1 200 OK\r\nConnection: close\r\n\r\n'

/**
 * 정해진 주소로 들어온 http 요청에 대해 query parameter string 을 callback 합니다.
 */
export default class TcpServer {

  static create({ sessionId = '', address = '127.0.0.1', port } = {}) {
    const tcpServer = new TcpServer({ sessionId, address, port })
    return tcpServer
  }
  
  /**
   * 
   * @param {string} address - tcp server host address
   * @param {number} port 
   */
  constructor({ sessionId = '', address = '127.0.0.1', port = DEFAULT_PORT } = {}) {
    this._address = address
    this._userReqPort = port
    this._sessionId = sessionId

    this._createServer()
  }

  /**
   * @param {Object} param 
   * @param {Function} param.hookCallback 
   * @param {Function} param.listenCallback - TCP Server 가 port open 하면 호출
   * @param {number} [param.portCountLimit=100] - 요청한 port 부터 + 100 까지
   */
  async startServerToHook({ hookCallback, listenCallback, portCountLimit = 100 }) {
    if (typeof hookCallback !== 'function' || typeof listenCallback !== 'function') {
      throw new Error('hookCallback is supposed to be a function')
    }

    this._hookCallback = hookCallback
    this._listenCallback = listenCallback

    for (let port = this._userReqPort ; port < this._userReqPort + portCountLimit ; port++) {
      if (port > 65535) {
        return this._listenCallback(new Error('can not find free port'), port)
      }

      const { error } = await this._startServerBySearchingFreePort(port)
      if (!error) {
        this._openPort = port
        return this._listenCallback(null, port)
      }
    }

    return this._listenCallback(new Error('can not find free port'))
  }

  _startServerBySearchingFreePort(port) {
    return new Promise(res => {
      // TODO 리스너 개수 체크 필요
      this._server.once('error', (error) => {
        if (error.code === 'EADDRINUSE') { this._server.close() }
        res({ error })
      })
      this._server.listen(port, this._address, () => {
        res({ port })
      })
    })
  }

  closeServer() {
    return new Promise((res, rej) => {
      if (this._server && this._server.listening) {
        this._disconnectAllConnections()
        this._server.close(() => res())
      } else {
        res()
      }
    })
  }
  
  _createServer() {
    this._initConnections()

    this._server = net.createServer(socket => {
      this._addConnection(socket)
      socket.on('close', this._removeConnection.bind(this, socket))
      socket.on('data', this._onData.bind(this, socket))
    })
  }

  _initConnections() {
    /**
     * @type {net.Socket[]}
     */
    this._connections = []
  }

  _addConnection(conn) {
    const foundConnection = this._connections.find(c => c.remotePort === conn.remotePort)
    if (!foundConnection) {
      this._connections.push(conn)
    }
  }

  _removeConnection(conn) {
    const foundConnection = this._connections.findIndex(c => c.remotePort === conn.remotePort)
    if (foundConnection !== -1) {
      this._connections.splice(foundConnection, 1)
    }
  }

  _disconnectAllConnections() {
    this._connections.forEach(socket => !socket.destroyed && socket.destroy())
  }

  async _onData(socket, data) {
    /** @type { { stopHttpHook: boolean, httpResponseString: string }|null } */
    let result = data && typeof this._hookCallback === 'function'
      ? await this._hookCallback({ sessionId: this._sessionId, port: this._openPort, data: data.toString() })
        : null
    
    if (socket && !socket.destroyed) {
      let resStr = HTTP_CLOSE_CONNECTION
      if (result && typeof result.httpResponseString === 'string') {
        resStr = result.httpResponseString
        if (!(resStr.endsWith('\n\n') || resStr.endsWith('\r\n\r\n'))) {
          resStr += '\r\n\r\n'
        }
      }

      socket.end(resStr)
    }
  }
}
